import { render, staticRenderFns } from "./TagAutoInputComponent.vue?vue&type=template&id=1a90c163"
import script from "./TagAutoInputComponent.vue?vue&type=script&lang=js"
export * from "./TagAutoInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports